<template>
    <a :href="href" class="nav-link cart-button" @click="openCart">
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9399 18.062L18.946 0.112122H1.05405L0.0602082 18.062C0.0589253 18.0898 0.0582838 18.1037 0.0578989 18.1176C0.057514 18.1315 0.0573856 18.1454 0.0571289 18.1733C0.0571289 19.2816 0.95256 20.1801 2.05713 20.1801H17.9429C17.9707 20.1798 17.9846 20.1797 17.9984 20.1793C18.0123 20.1789 18.0262 20.1783 18.0539 20.177C19.1567 20.1155 20.0011 19.1686 19.9399 18.062ZM2.05713 18.1733L2.94602 2.11892H17.0541L17.943 18.1733H2.05713Z" fill="#0D042B"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 4.1257H7V6.63419C7 7.88681 8.38514 9.14269 10 9.14269C11.6149 9.14269 13 7.88681 13 6.63419V4.1257L15 4.1257V6.63419C15 9.04305 12.6768 11.1495 10 11.1495C7.32324 11.1495 5 9.04305 5 6.63419V4.1257Z" fill="#0D042B"/>
        </svg>
        <span v-if="!fareHarborMode()" class="badge rounded-pill bg-primary">{{ totalNumber }}</span>
    </a>
</template>

<script>
import {mapGetters} from "vuex";
import FareHarborMixin from "../../../mixins/FareHarborMixin";

export default {
    name: "Cart",
    mixins: [FareHarborMixin],
    computed: {
        ...mapGetters('cart', ['totalNumber']),
        href() {
            const link = this.fareHarborModeLink()
            return link ? link : '/checkout'
        }
    },
    methods: {
        openCart() {
            if (this.fareHarborMode()) this.openFareHarborModal();
        }
    }
}
</script>

<style scoped>

</style>
